// RegExp object for contract addresses
// '0x' + 40 case-insensitive hexadecimal characters
export const contractAddrRegEx = new RegExp('0x[0-9a-fA-F]{40}$');
